exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".connect-tabs .md-tabs-navigation-container{background-color:#4d656d}.connect-tabs .md-tab-header{background-color:rgba(34,85,102,.7);border-bottom:6px solid #f2f2f2}.connect-tabs .md-tab-header:hover{background-color:rgba(34,85,102,.4)}.connect-tabs span{font-weight:700;font-family:Verdana,Arial,Helvetica,sans-serif}.connect-tabs .md-active span{color:#f2f2f2}.connect-tabs .md-active{background-color:#256}.connect-tabs .md-tab-indicator{background-color:#1d323a!important;height:6px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4eadbab4","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/peers/ReviewConnections.vue
// module id = 965
// module chunks = 0